import React, { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { PostRequest } from "@/lib/http";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Mail } from "lucide-react";

const UnverifiedEmailPop = () => {
  const [showDialog, setShowDialog] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleResendVerification = async () => {
    // Add your resend verification logic here
    const { err } = await PostRequest({
      url: "/api/resend-verification",
      setState: setLoading,
    });
    if (!err) {
      toast.success("Verification email re-sent successfully");
      setShowDialog(false);
    } else {
      toast.error(err);
    }
  };

  return (
    <AlertDialog open={showDialog} onOpenChange={setShowDialog}>
      <AlertDialogContent className="dark:border-darkBorder">
        <AlertDialogHeader>
          <AlertDialogTitle>Email Verification Required</AlertDialogTitle>
          <AlertDialogDescription>
            Your email address has not been verified yet. Please check your
            inbox for the verification email. If you haven't received the email,
            you can request a new verification link.
            <br />
            <Button
              onClick={handleResendVerification}
              disabled={loading}
              variant="outline"
              className="mt-2 cursor-pointer"
            >
              {loading ? (
                "Sending..."
              ) : (
                <>
                  <Mail /> Resend Verification
                </>
              )}
            </Button>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={() => setShowDialog(false)}
            className="cursor-pointer text-white"
          >
            Check Later
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default UnverifiedEmailPop;
